import { BasicScrollView } from '@/components/BasicScrollView';
import SubdomainHomepage from '@/components/SubdomainHomepage';
import * as AppUtilities from '@/utilities/AppUtilities';
import Head from 'expo-router/head';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import Footer from '@/components/Footer';
import * as AppConsts from '@/utilities/AppConsts';
import { Meta } from '@/components/Meta';

export default function Index() {

  const community = useSelector((state: RootState) => state.user.current_community);

  if (AppUtilities.DEBUGLEVEL.dev) {
    AppUtilities.info("(community-loggedin-nonmember-stack)/ render");
  }

  return (
    <BasicScrollView center={true}>
      <Meta />
      <SubdomainHomepage />
      <Footer home={false} rabblHome={true} />
    </BasicScrollView>
  );
}
